import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EntityServiceError } from '../shared/errors/entity-service.error';
import { PricingTableSession } from './models/pricing-table-dialog.model';

export const PricingTableDialogActions = createActionGroup({
  source: 'Pricing Table Dialog Actions',
  events: {
    Opened: emptyProps(),
    Closed: emptyProps(),
  },
});

export const PricingTableDialogEffectActions = createActionGroup({
  source: 'Pricing Table Dialog Effect',
  events: {
    'Load Pricing Table Succeeded': props<{ pricingTableSession: PricingTableSession }>(),
    'Load Pricing Table Errored': props<{ error: EntityServiceError }>(),
  },
});
